import { createContext, use } from "react";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import type { DataModelConfiguration } from "../../../../api/types/dataModelConfigurationTypes";
import type { ClientConfigurationAssignment } from "./configurationsListState";

export interface Props {
  configurations: DataModelConfiguration[];
  onRenameConfiguration: (id: string) => void;
  onDeleteConfiguration: (id: string) => void;
  onAssignClient: (clientAssignment: ClientConfigurationAssignment) => void;
}

export const ConfigurationsGridActionsContext = createContext<Props | undefined>(undefined);

export const useConfigurationsGridActionsContext = () =>
  defined(use(ConfigurationsGridActionsContext), "Attempt to use ConfigurationsGridActionsContext without provider");
